import { SxProps } from "@mui/material";

export type Styles = {
  [key: string]: SxProps;
};

export type StepperData = {
  label: string;
  value: string;
  stepNumber: number;
  selected: boolean;
  completed: boolean;
  showArrow: boolean;
};

export type CountryListItem = {
  idValue: string;
  textValue: string;
  isoCode: string;
};

export type SelectedCountry = {
  value: string;
  label: string;
  isoCode: string;
};

export type stepProps = {
  toggleSteps: Function;
  stepDataManager: Function;
};

export type stepCancelProps = {
  toggleSteps: Function;
  stepDataManager: Function;
};

export type ExamItem = {
  availability: string;
  currencyCode: string;
  currencySymbol: string;
  examCentreId: string | null;
  examDate: Date;
  examFormat: string;
  examId: string;
  examName: string;
  hideCurrency: boolean;
  isClosed: boolean;
  isClosedOrFull: boolean;
  isComputerBased: boolean;
  isExamEligibleForUkVisa: boolean;
  isSchoolExam: boolean;
  lateExamFeeAddedMessage?: string;
  lateFeePrice: string;
  placesAvailable: number;
  price: number;
  priceString: string;
  requiresPhotoConsent: boolean;
  showWarningMessage: boolean;
  speakingTestDate: string | null;
  warningMessage: string | null;
};

export type CandidateDetails = {
  firstName: string;
  lastName: string;
  gender: { label: string; value: string };
  age: number;
  day: { label: string | number; value: number };
  month: { label: string | number; value: number };
  year: { label: string | number; value: number };
  address: string;
  addressLine2: string;
  city: string;
  addressLine4: string;
  country: { label: string; value: string };
  email: string;
  confirmEmail: string;
  languageCode: string;
  examReason: { label: string; value: string };
  phoneNo: string;
  telephoneNo: string;
  guardianConfirmEmail: string;
  guardianEmail: string;
  guardianfirstName: string;
  guardianlastName: string;
  guardianmobilenumber: string;
  guardianphonenumber: string;
  specialRequestType: { label: string; value: string };
  specialRequestMessage: string;
};

export enum ReasonForExam {
  UKVisaPurposes = "1",
  EmigrationPurposes = "2",
  EducationPurposesInCountry = "3",
  EducationPurposesAbroad = "4",
  EmploymentInCountry = "5",
  EmploymentAbroad = "6",
  PersonalPurposes = "7",
  Other = "8",
}

export enum CountryLabel {
  Myanmar = "Myanmar",
  HongKong = "Hong Kong",
  Morocco = "Morocco",
}
